import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-blanksimsuccess',
  templateUrl: './blanksimsuccess.component.html',
  styleUrls: ['./blanksimsuccess.component..scss']
})
export class BlanksimsuccessComponent implements OnInit {
  @Input() email: any;
  @Input() orderId: any;
  constructor() { }

  ngOnInit(): void {
  }

}
